import { type AxiosError, type AxiosRequestConfig } from 'axios';

import { customInstance as baseCustomInstance } from '@services/base/apiService';

export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
  baseUrl?: string,
): Promise<T> => baseCustomInstance<T>(config, options, baseUrl);

export type ErrorType<Error> = AxiosError<Error>;
